import { __rest, __assign } from 'tslib';
import React, { useMemo, useCallback } from 'react';
import { VirtualOptionsList, BaseOption } from '../../../../select/esm/shared';
import { getDataTestId } from '../../../../shared/esm';
import { WorldMagnifierMIcon } from '@alfalab/icons-glyph/WorldMagnifierMIcon';
import { FlagIcon } from '../flag-icon/component.js';
import { EMPTY_COUNTRY_SELECT_FIELD, SelectField } from '../select-field/component.js';
import 'classnames';
import '../flag-icon/flagSprite.js';
import 'react-merge-refs';
import '@alfalab/hooks';

var styles = {"component":"international-phone-input__component_j0inb","option":"international-phone-input__option_j0inb","flag":"international-phone-input__flag_j0inb","countryName":"international-phone-input__countryName_j0inb","dialCode":"international-phone-input__dialCode_j0inb","flagIconWrapper":"international-phone-input__flagIconWrapper_j0inb","emptyCountryIcon":"international-phone-input__emptyCountryIcon_j0inb"};
require('./index.css');

var CountrySelect = function (_a) {
    var hideCountrySelect = _a.hideCountrySelect, countries = _a.countries, country = _a.country, dataTestId = _a.dataTestId, fieldWidth = _a.fieldWidth, onChange = _a.onChange, _b = _a.view, view = _b === void 0 ? 'desktop' : _b, SelectComponent = _a.SelectComponent, restProps = __rest(_a, ["hideCountrySelect", "countries", "country", "dataTestId", "fieldWidth", "onChange", "view", "SelectComponent"]);
    var options = useMemo(function () {
        return (countries === null || countries === void 0 ? void 0 : countries.map(function (areas) {
            var _a = areas[0], iso2 = _a.iso2, dialCode = _a.dialCode, name = _a.name;
            return {
                key: iso2,
                value: areas[0],
                content: (React.createElement("span", { className: styles.option },
                    React.createElement(FlagIcon, { country: iso2, className: styles.flag }),
                    React.createElement("span", { className: styles.optionTextWrap },
                        React.createElement("span", { className: styles.countryName }, name),
                        React.createElement("span", { className: styles.dialCode },
                            "+",
                            dialCode)))),
            };
        })) || [];
    }, [countries]);
    var renderOptionsList = useCallback(function (props) { return (React.createElement("div", { style: { width: fieldWidth || 0 } },
        React.createElement(VirtualOptionsList, __assign({}, props, { optionsListWidth: 'field' })))); }, [fieldWidth]);
    var renderFlagIcon = function () { return (React.createElement("span", { className: styles.flagIconWrapper }, (country === null || country === void 0 ? void 0 : country.iso2) ? (React.createElement(FlagIcon, { country: country.iso2 })) : (React.createElement(WorldMagnifierMIcon, { className: styles.emptyCountryIcon })))); };
    var renderCountrySelect = function () {
        var _a;
        var selected = (_a = options.find(function (c) { return c.key === (country === null || country === void 0 ? void 0 : country.iso2); })) === null || _a === void 0 ? void 0 : _a.key;
        return (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        React.createElement("div", { className: styles.component, onClick: function (event) { return event.stopPropagation(); } },
            React.createElement(SelectComponent, __assign({ Option: BaseOption }, restProps, { dataTestId: getDataTestId(dataTestId, 'country-select'), options: options, selected: selected || EMPTY_COUNTRY_SELECT_FIELD, onChange: onChange, Field: SelectField, OptionsList: view === 'mobile' ? VirtualOptionsList : renderOptionsList }, (view === 'mobile' && {
                bottomSheetProps: {
                    title: 'Выберите страну',
                },
            })))));
    };
    return hideCountrySelect || options.length < 2 ? renderFlagIcon() : renderCountrySelect();
};

export { CountrySelect };
